// Hook to upsert the tenantProviderAuth

/*  Shared  */
import { debug } from 'application/Shared/Utils';
import { ProviderType } from 'application/Shared/types/tenantProvider';

/*  NPM  */
import axios, { AxiosError } from 'axios';

/*  React  */
import { useCallback, useRef, useState } from 'react';

interface TenantProviderAuth {
    authData: {
        [key: string]: string;
    };
    platformTenantId: string;
    providerType: ProviderType;
}

export const useCreateTenantProviderAuthAsync = () => {
    const [saving, setSaving] = useState(false);
    const error = useRef('');
    const success = useRef(false);

    const createTenantProviderAuth = useCallback(
        async (providerAuth: TenantProviderAuth) => {
            try {
                error.current = '';
                setSaving(true);
                await axios.post('/tenantProviderAuth', {
                    ...providerAuth,
                    upsert: true
                });
                success.current = true;
            } catch (err) {
                debug.e('Error creating tenant provider auth.', err);
                const axiosErr = err as AxiosError<{ message?: string }>;
                error.current =
                    axiosErr.response?.data?.message ??
                    (axiosErr.message ||
                        `Unable to connect to provider ${providerAuth.providerType}. Please try again.`);
            }
            setSaving(false);
            return {
                error: error.current,
                success: success.current
            };
        },
        []
    );

    return { createTenantProviderAuth, saving };
};
